/**
 * Sample Tray — Adds "Add more samples" flow to colour tray
 *
 * Layers sample-selection behaviour on top of the colour tray grid
 * (rendered by colour-tray.liquid's inline script).
 */
(function() {
  'use strict';

  var SAMPLE_PRICE = 200;
  var sampleMode = false;
  var selectedSamples = {};
  var cartSampleIds = [];
  var cachedProducts = null;
  var cachedCollectionHandle = null;
  var batchAdding = false;
  var _gridObserver = null;
  var _augmentTimer = null;

  /* ── Footer ── */

  function ensureFooter() {
    var tray = document.querySelector('.ct-tray');
    if (!tray) return;
    var existing = tray.querySelector('[data-ct-footer]');
    if (existing) {
      var btn = existing.querySelector('[data-ct-batch-add]');
      if (btn && !btn._stBound) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (!btn.classList.contains('ct-tray-footer__cta--disabled')) batchAdd();
        });
        btn._stBound = true;
      }
      return;
    }
    var footer = document.createElement('div');
    footer.className = 'ct-tray-footer';
    footer.dataset.ctFooter = '';
    footer.hidden = true;
    footer.innerHTML =
      '<div class="ct-tray-footer__summary">' +
        '<span data-ct-count>0</span> samples \u2014 <span data-ct-total>\u00a30.00</span>' +
      '</div>' +
      '<a role="button" tabindex="0" class="ct-tray-footer__cta ct-tray-footer__cta--disabled" data-ct-batch-add>ADD ALL TO BASKET</a>';
    tray.appendChild(footer);
    var newBtn = footer.querySelector('[data-ct-batch-add]');
    newBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (!newBtn.classList.contains('ct-tray-footer__cta--disabled')) batchAdd();
    });
    newBtn._stBound = true;
  }

  /* ── Patch success sheet ── */

  function patchSuccessSheet() {
    var sheets = document.querySelectorAll('.sf-sheet__success, .sf-sheet__paid');
    sheets.forEach(function(sheet) {
      var existingCta = sheet.querySelector('.sf-sheet__cta[data-action="close-sheet"], .sf-sheet__cta[data-action="add-more-samples"]');
      if (!existingCta || existingCta.dataset.action === 'add-more-samples') return;

      existingCta.dataset.action = 'add-more-samples';
      var textEl = existingCta.querySelector('.sf-sheet__cta-text');
      if (textEl) textEl.textContent = 'ADD MORE SAMPLES';

      var swatchRow = document.createElement('span');
      swatchRow.className = 'sf-sheet__cta-swatches';
      existingCta.classList.add('sf-sheet__cta--samples');
      existingCta.appendChild(swatchRow);

      var swatchColors = ['#D6CCB8', '#71957B', '#C1ACC8'];
      for (var sc = 0; sc < swatchColors.length; sc++) {
        var dot = document.createElement('span');
        dot.className = 'sf-sheet__cta-swatch';
        dot.style.backgroundColor = swatchColors[sc];
        swatchRow.appendChild(dot);
      }
    });

    var hints = document.querySelectorAll('.sf-sheet__success-hint');
    hints.forEach(function(h) { h.textContent = 'Extra samples are just \u00a32.00 each.'; });
  }

  /* ── Safety net: block ALL card navigation when in sample mode ── */
  /* These fire in the capture phase, before any card href can navigate. */
  /* This is the primary defence — even if augmentCards completely fails, */
  /* no card will navigate away while sampleMode is true. */

  document.addEventListener('click', function(e) {
    if (!sampleMode) return;
    var card = e.target.closest('.ct-card');
    if (!card) return;
    var grid = card.closest('[data-ct-grid]');
    if (!grid) return;
    e.preventDefault();
    e.stopPropagation();
    // If card has been augmented, let the per-card handler run via toggleSample
    var btn = card.querySelector('.ct-card__sample-add');
    if (btn && !card.classList.contains('ct-card--in-cart')) {
      var handle = card.dataset.handle;
      var variantId = parseInt(card.dataset.sampleVariantId, 10);
      if (handle && variantId) {
        toggleSample(handle, variantId, card, btn);
      }
    }
  }, true);

  document.addEventListener('touchend', function(e) {
    if (!sampleMode) return;
    var card = e.target.closest('.ct-card');
    if (!card) return;
    var grid = card.closest('[data-ct-grid]');
    if (!grid) return;
    // Only prevent default on unaugmented cards — augmented cards use the click handler
    if (!card.querySelector('.ct-card__sample-add')) {
      e.preventDefault();
    }
  }, { passive: false, capture: true });

  /* ── "Add more samples" click handler ── */

  document.addEventListener('click', function(e) {
    var action = e.target.closest('[data-action="add-more-samples"]');
    if (!action) return;

    var overlay = action.closest('.sf-sheet-overlay');
    if (overlay) {
      overlay.classList.remove('sf-sheet--open');
      setTimeout(function() {
        overlay.setAttribute('hidden', '');
        overlay.setAttribute('aria-hidden', 'true');
      }, 250);
      document.body.style.overflow = '';
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartSampleIds = [];
        cart.items.forEach(function(item) {
          var t = (item.variant_title || item.title || '').toLowerCase();
          if (t.indexOf('sample') > -1 || t.indexOf('100ml') > -1 || t.indexOf('tester') > -1 || t.indexOf('a6') > -1) {
            cartSampleIds.push(item.variant_id);
          }
        });
        openSampleMode();
      })
      .catch(function() { openSampleMode(); });
  });

  /* ── Open sample mode ── */

  function openSampleMode() {
    sampleMode = true;
    selectedSamples = {};

    var seeAllBtn = document.querySelector('[data-ct-open]');
    if (seeAllBtn) seeAllBtn.click();

    // Pre-fetch products in parallel with waiting for grid
    var productsReady = new Promise(function(resolve) {
      getProducts(function(products) { resolve(products); });
    });

    waitForGrid(function() {
      ensureFooter();

      var overlay = document.getElementById('colour-tray');
      var tray = overlay ? overlay.querySelector('.ct-tray') : null;
      var trayTitle = overlay ? overlay.querySelector('[data-ct-tray-title]') : null;
      if (!tray) return;

      tray.classList.add('ct-tray--sample-mode');
      if (trayTitle) trayTitle.textContent = 'Add more samples \u2014 \u00a32.00 each';

      var footer = tray.querySelector('[data-ct-footer]');
      if (footer) footer.hidden = false;
      updateFooter();

      // Neuter all card hrefs immediately so Safari can't navigate
      neuterCardHrefs();

      // Add loading class to unaugmented cards
      var allCards = tray.querySelectorAll('.ct-card');
      allCards.forEach(function(c) {
        if (!c.querySelector('.ct-card__sample-add')) {
          c.classList.add('ct-card--loading');
        }
      });

      // Wait for products before augmenting
      productsReady.then(function() {
        augmentCards();
        observeGrid();
      });
    });
  }

  /* ── Neuter/restore card hrefs ── */

  function neuterCardHrefs() {
    var cards = document.querySelectorAll('[data-ct-grid] .ct-card');
    cards.forEach(function(card) {
      if (card.tagName === 'A' && card.getAttribute('href')) {
        if (!card.dataset.originalHref) {
          card.dataset.originalHref = card.getAttribute('href');
        }
        card.removeAttribute('href');
      }
    });
  }

  function restoreCardHrefs() {
    document.querySelectorAll('.ct-card[data-original-href]').forEach(function(c) {
      c.setAttribute('href', c.dataset.originalHref);
      c.removeAttribute('data-original-href');
    });
  }

  /* ── Wait for grid ── */

  function waitForGrid(callback, attempts) {
    attempts = attempts || 0;
    var grid = document.querySelector('[data-ct-grid]');
    var hasCards = grid && grid.querySelectorAll('.ct-card').length >= 2;
    if (hasCards) {
      callback();
    } else if (attempts < 50) {
      setTimeout(function() { waitForGrid(callback, attempts + 1); }, 100);
    }
  }

  /* ── Grid observer — catches cards added after initial augment ── */

  function observeGrid() {
    if (_gridObserver) _gridObserver.disconnect();
    var grid = document.querySelector('[data-ct-grid]');
    if (!grid) return;

    _gridObserver = new MutationObserver(function() {
      if (!sampleMode) return;
      clearTimeout(_augmentTimer);
      _augmentTimer = setTimeout(function() {
        neuterCardHrefs();
        augmentCards();
      }, 150);
    });
    _gridObserver.observe(grid, { childList: true });
  }

  /* ── Get products ── */

  function getProducts(callback) {
    var section = document.getElementById('ColourTray');
    var currentHandle = section ? section.dataset.collectionHandle : null;
    if (cachedProducts && cachedCollectionHandle === currentHandle) {
      callback(cachedProducts);
      return;
    }
    cachedCollectionHandle = currentHandle;

    if (!section) { callback([]); return; }

    var handleMap = {
      'interior-emulsion': 'interior-walls-ceilings-emulsion-paint',
      'front-door-paint': 'front-door-paints',
      'exterior-masonry-paint': 'masonry-paints',
      'exterior-masonry': 'masonry-paints',
      'front-door': 'front-door-paints',
      'masonry': 'masonry-paints'
    };
    var rawHandle = section.dataset.collectionHandle;
    var handle = handleMap[rawHandle] || rawHandle;

    fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products || [];
        if (products.length === 250) {
          return fetch('/collections/' + handle + '/products.json?limit=250&page=2', { credentials: 'same-origin' })
            .then(function(r2) { return r2.json(); })
            .then(function(data2) {
              return products.concat(data2.products || []);
            })
            .catch(function() { return products; });
        }
        return products;
      })
      .then(function(allProducts) {
        cachedProducts = allProducts;
        callback(cachedProducts);
      })
      .catch(function() {
        cachedProducts = [];
        callback([]);
      });
  }

  /* ── Augment cards ── */

  function augmentCards() {
    getProducts(function(products) {
      var grid = document.querySelector('[data-ct-grid]');
      if (!grid) return;

      var cards = grid.querySelectorAll('.ct-card');
      cards.forEach(function(card) {
        // ── Refresh existing augmented card ──
        var existingBtn = card.querySelector('.ct-card__sample-add');
        if (existingBtn) {
          card.classList.remove('ct-card--selected', 'ct-card--in-cart', 'ct-card--loading');
          var svid = parseInt(card.dataset.sampleVariantId, 10);
          if (cartSampleIds.indexOf(svid) > -1) {
            card.classList.add('ct-card--in-cart');
            existingBtn.textContent = 'In basket';
          } else {
            existingBtn.textContent = 'Add sample';
          }
          // Ensure href is neutered
          if (card.tagName === 'A' && card.getAttribute('href')) {
            if (!card.dataset.originalHref) card.dataset.originalHref = card.getAttribute('href');
            card.removeAttribute('href');
          }
          return;
        }

        // ── Extract handle ──
        var cardHandle = card.dataset.handle;
        if (!cardHandle) {
          var href = (card.dataset.originalHref || card.getAttribute('href') || '')
            .split('?')[0].split('#')[0].replace(/\/+$/, '');
          var parts = href.split('/');
          cardHandle = parts[parts.length - 1];
          if (cardHandle) card.dataset.handle = cardHandle;
        }
        if (!cardHandle) {
          card.classList.remove('ct-card--loading');
          return;
        }

        // ── Match product ──
        var product = null;
        for (var i = 0; i < products.length; i++) {
          if (products[i].handle === cardHandle) { product = products[i]; break; }
        }
        if (!product || !product.variants) {
          card.classList.remove('ct-card--loading');
          return;
        }

        // ── Find sample variant ──
        var sampleVariant = null;
        var cheapestVariant = null;
        for (var v = 0; v < product.variants.length; v++) {
          var vt = (product.variants[v].title || '').toLowerCase();
          if (vt.indexOf('sample') > -1 || vt.indexOf('100ml') > -1 || vt.indexOf('tester') > -1 || vt.indexOf('a6') > -1 || vt.indexOf('swatch') > -1) {
            sampleVariant = product.variants[v];
            break;
          }
          var vPrice = parseInt(product.variants[v].price, 10);
          if (vPrice > 0 && vPrice <= SAMPLE_PRICE && (!cheapestVariant || vPrice < parseInt(cheapestVariant.price, 10))) {
            cheapestVariant = product.variants[v];
          }
        }
        if (!sampleVariant && cheapestVariant) sampleVariant = cheapestVariant;
        if (!sampleVariant) {
          card.classList.remove('ct-card--loading');
          return;
        }

        card.dataset.sampleVariantId = sampleVariant.id;

        // ── Neuter href ──
        if (card.tagName === 'A' && card.getAttribute('href')) {
          if (!card.dataset.originalHref) card.dataset.originalHref = card.getAttribute('href');
          card.removeAttribute('href');
        }

        // ── Build UI elements ──
        var priceLabel = document.createElement('div');
        priceLabel.className = 'ct-card__sample-price';
        priceLabel.textContent = '\u00a32.00';
        card.appendChild(priceLabel);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ct-card__sample-add';
        card.appendChild(btn);

        var swatchEl = card.querySelector('.ct-card__swatch');
        if (swatchEl && !swatchEl.querySelector('.ct-card__check')) {
          var check = document.createElement('div');
          check.className = 'ct-card__check';
          check.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5.5l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          swatchEl.appendChild(check);
        }

        if (cartSampleIds.indexOf(sampleVariant.id) > -1) {
          card.classList.add('ct-card--in-cart');
          btn.textContent = 'In basket';
        } else {
          btn.textContent = 'Add sample';
        }

        card.classList.remove('ct-card--loading');
      });
    });
  }

  /* ── Toggle sample selection ── */

  function toggleSample(handle, variantId, card, btn) {
    if (selectedSamples[handle]) {
      delete selectedSamples[handle];
      card.classList.remove('ct-card--selected');
      btn.textContent = 'Add sample';
    } else {
      selectedSamples[handle] = { variantId: variantId };
      card.classList.add('ct-card--selected');
      btn.textContent = 'Added';
    }
    updateFooter();
  }

  /* ── Footer update — always queries fresh DOM ── */

  function updateFooter() {
    var footerCount = document.querySelector('[data-ct-count]');
    var footerTotal = document.querySelector('[data-ct-total]');
    var footerBtn = document.querySelector('[data-ct-batch-add]');

    var count = Object.keys(selectedSamples).length;
    var total = count * SAMPLE_PRICE;

    if (footerCount) footerCount.textContent = count;
    if (footerTotal) footerTotal.textContent = ('\u00a3' + (total / 100).toFixed(2)).replace(/\.00$/, '');
    if (footerBtn) {
      if (count === 0) {
        footerBtn.classList.add('ct-tray-footer__cta--disabled');
      } else {
        footerBtn.classList.remove('ct-tray-footer__cta--disabled');
      }
    }
  }

  /* ── Batch add to cart ── */

  function batchAdd() {
    if (batchAdding) return;
    var keys = Object.keys(selectedSamples);
    if (!keys.length) return;
    batchAdding = true;

    var batchBtn = document.querySelector('[data-ct-batch-add]');
    if (batchBtn) {
      batchBtn.classList.add('ct-tray-footer__cta--disabled');
      batchBtn.textContent = 'ADDING\u2026';
    }

    var items = keys.map(function(h) {
      return { id: parseInt(selectedSamples[h].variantId, 10), quantity: 1 };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['cart-drawer', 'cart-bubble', 'main-cart'],
        sections_url: window.location.pathname
      })
    })
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.status) throw new Error(response.description || 'Add failed');

        if (response.sections) {
          ['Cart-Drawer', 'cart-drawer-toggle'].forEach(function(id) {
            var container = document.getElementById(id);
            if (!container) return;
            var sectionKey = id === 'Cart-Drawer' ? 'cart-drawer' : 'cart-bubble';
            var selector = id === 'Cart-Drawer' ? '.cart-drawer' : '.thb-item-count';
            if (response.sections[sectionKey]) {
              var el = container.querySelector(selector) || container;
              var parsed = new DOMParser()
                .parseFromString(response.sections[sectionKey], 'text/html')
                .querySelector(selector);
              if (parsed) el.innerHTML = parsed.innerHTML;
            }
          });
        }

        batchAdding = false;

        // Let the browser paint the cart drawer updates before closing the tray
        requestAnimationFrame(function() {
          closeSampleMode();
          document.body.classList.add('open-cc', 'open-cart');
          var drawer = document.getElementById('Cart-Drawer');
          if (drawer) drawer.classList.add('active');
          if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
        });
      })
      .catch(function(err) {
        console.error('Batch add failed:', err);
        batchAdding = false;
        var batchBtn2 = document.querySelector('[data-ct-batch-add]');
        if (batchBtn2) {
          batchBtn2.textContent = 'Something went wrong';
          setTimeout(function() {
            batchBtn2.textContent = 'ADD ALL TO BASKET';
            batchBtn2.classList.remove('ct-tray-footer__cta--disabled');
          }, 2000);
        }
      });
  }

  /* ── Close sample mode ── */

  function closeSampleMode() {
    sampleMode = false;
    selectedSamples = {};
    batchAdding = false;

    if (_gridObserver) { _gridObserver.disconnect(); _gridObserver = null; }
    clearTimeout(_augmentTimer);

    restoreCardHrefs();

    var overlay = document.getElementById('colour-tray');
    if (overlay) {
      overlay.classList.remove('ct-open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';

    var tray = overlay ? overlay.querySelector('.ct-tray') : null;
    if (tray) tray.classList.remove('ct-tray--sample-mode');

    var footer = document.querySelector('[data-ct-footer]');
    if (footer) footer.hidden = true;

    // Reset footer button text in case it was left as "ADDING..."
    var footerBtn = document.querySelector('[data-ct-batch-add]');
    if (footerBtn) {
      footerBtn.textContent = 'ADD ALL TO BASKET';
      footerBtn.classList.add('ct-tray-footer__cta--disabled');
    }

    document.querySelectorAll('.ct-card--selected').forEach(function(c) { c.classList.remove('ct-card--selected'); });
    document.querySelectorAll('.ct-card--in-cart').forEach(function(c) { c.classList.remove('ct-card--in-cart'); });
    document.querySelectorAll('.ct-card--loading').forEach(function(c) { c.classList.remove('ct-card--loading'); });
  }

  /* ── Watch for tray being closed externally (backdrop click, Escape key) ── */

  var colourTray = document.getElementById('colour-tray');
  if (colourTray) {
    var trayObserver = new MutationObserver(function() {
      if (sampleMode && colourTray.getAttribute('aria-hidden') === 'true') {
        // Tray was closed by the colour tray's own close() — reset sample mode
        sampleMode = false;
        selectedSamples = {};
        batchAdding = false;
        if (_gridObserver) { _gridObserver.disconnect(); _gridObserver = null; }
        clearTimeout(_augmentTimer);
        restoreCardHrefs();
        var tray = colourTray.querySelector('.ct-tray');
        if (tray) tray.classList.remove('ct-tray--sample-mode');
        var footer = document.querySelector('[data-ct-footer]');
        if (footer) footer.hidden = true;
        var footerBtn2 = document.querySelector('[data-ct-batch-add]');
        if (footerBtn2) {
          footerBtn2.textContent = 'ADD ALL TO BASKET';
          footerBtn2.classList.add('ct-tray-footer__cta--disabled');
        }
        document.querySelectorAll('.ct-card--selected').forEach(function(c) { c.classList.remove('ct-card--selected'); });
        document.querySelectorAll('.ct-card--in-cart').forEach(function(c) { c.classList.remove('ct-card--in-cart'); });
        document.querySelectorAll('.ct-card--loading').forEach(function(c) { c.classList.remove('ct-card--loading'); });
      }
    });
    trayObserver.observe(colourTray, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* ── Init ── */

  patchSuccessSheet();
  document.addEventListener('cart:item-added', function() {
    setTimeout(patchSuccessSheet, 100);
  });

  // Inject loading style
  var loadingStyle = document.createElement('style');
  loadingStyle.textContent = '.ct-card--loading { opacity: 0.4; pointer-events: none; }';
  document.head.appendChild(loadingStyle);
})();
